import { Component, inject } from '@angular/core';
import { CookieInputInterface, CookieInputServiceInterface, COOKIE_INPUT_TOKEN } from '@campus/cookies';
import { ENVIRONMENT_PLATFORM_TOKEN } from '@campus/environment';

import '@diekeure/dcr-components/dcr-logo.js';
import '@diekeure/dcr-components/dcr-outline-button.js';
import { Observable } from 'rxjs';

@Component({
  selector: 'campus-portal-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class PortalFooterComponent {
  public platform = inject(ENVIRONMENT_PLATFORM_TOKEN);
  public year = new Date().getFullYear();

  public cookieInputs$: Observable<CookieInputInterface>;

  private _cookieInputService: CookieInputServiceInterface = inject(COOKIE_INPUT_TOKEN);

  public ngOnInit() {
    this.cookieInputs$ = this._cookieInputService.cookieInputs$;
  }

  public openCookieConsent(event: Event) {

    event.preventDefault();

    this._cookieInputService.setCookieInputs({
      visibility: true,
    });
  }

  public closeCookieConsent() {
    this._cookieInputService.setCookieInputs({ visibility: false });
  }
}
